module.exports = __webpack_public_path__ + "static/img/1-1Z52F95U3E1.b239e59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z52F95U3E1.jpg
// module id = RMM/
// module chunks = 0